import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../../Componentes/Basicos/LVGridDetalle";
import LVButtonAccion from "../../../Componentes/Basicos/LVButtonAccion";
import { function_ABM_ART_Articulos_Clonar } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";

class ABM_ART_Articulos_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true
    };
  }

  handleOnClickClonar = async () => {
    try {
      const CodigoArticulo = this.props.data.data.CodigoArticulo
      const CodigoArticuloNuevo = prompt("Ingresá el nuevo Código de Artículo:");

      if (!CodigoArticuloNuevo) {
        alert("Clonación cancelada. No se ingresó un código nuevo.");
        return;
      }

      await function_ABM_ART_Articulos_Clonar(CodigoArticulo, CodigoArticuloNuevo)

      alert("Se ha generado el nuevo Artículo");
    } catch (error) {
      alert("Error al clonar Artículo:" + error);
    }
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { ABM_ART_Articulos: { function_ABM_ART_Articulos_Leer } } = require('neftis7_apicaller');
      const resultData = await function_ABM_ART_Articulos_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.CodigoArticulo)
  };

  render() {
    return (
      <React.Fragment>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", alignItems: "flex-start" }}>
          {this.state.loadingUnidadesMedida ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListArticulosUnidadesMedida && this.state.data[0].ListArticulosUnidadesMedida.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListArticulosUnidadesMedida}
                    Titulo="Unidades de Medida"
                  >
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="400" alignment="Left" dataType="string" />
                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingTamanos ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListArticulosTamanos && this.state.data[0].ListArticulosTamanos.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListArticulosTamanos}
                    Titulo="Tamaños"
                  >
                    <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="400" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingPresentaciones ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListArticulosPresentaciones && this.state.data[0].ListArticulosPresentaciones.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListArticulosPresentaciones}
                    Titulo="Presentaciones"
                  >
                    <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="400" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingPresentaciones ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListArticulosProveedores && this.state.data[0].ListArticulosProveedores.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListArticulosProveedores}
                    Titulo="Proveedores"
                  >
                    <Column caption="Código" dataField="CodigoPresentacion" width="90" alignment="Left" dataType="string" />
                    <Column caption="Razón Social" dataField="ABM_EEX_Proveedores_RazonSocial" width="200" alignment="Left" dataType="string" />

                    <Column caption="Factura" alignment="Center">
                      <Column caption="Doc.Compra" dataField="IdDocCompra" width="100" alignment="Right" dataType="number" />
                      <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />

                      <Column caption="Neto" dataField="ImporteNeto" width="100" alignment="Right" dataType="number" format="currency" />
                      <Column caption="I.V.A." dataField="ImporteIVA" width="100" alignment="Right" dataType="number" format="currency" />
                      <Column caption="Descuentos" dataField="ImporteDescuentos" width="90" alignment="Right" dataType="number" format="currency" />
                      <Column caption="Recargos" dataField="ImporteRecargos" width="90" alignment="Right" dataType="number" format="currency" />
                    </Column>
                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingPlantas ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListPlantas && this.state.data[0].ListPlantas.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListPlantas}
                    Titulo="Plantas"
                  >
                    <Column caption="Código" dataField="CodigoPlanta" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingEmpresas ? null : (
            <>
              {this.state.data[0] && this.state.data[0].ListEmpresas && this.state.data[0].ListEmpresas.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data[0].ListEmpresas}
                    Titulo="Empresas"
                  >
                    <Column caption="Código" dataField="CodigoEmpresa" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px", width: "250px" }}>
              <LVButtonAccion Texto={"CLONAR"} onClick={this.handleOnClickClonar} />
            </div>
          </div>
        </div>
      </React.Fragment >
    );
  }
}

export default ABM_ART_Articulos_Detalle;
